export const PT_FREE_PERKS = [
  '1 usuário',
  '50 GB de armazenamento',
  'Projetos (limitados)',
  'Briefings, propostas e CRM',
  'Documentos, relatórios e checklists',
  'App para iOS e Android',
  'Assistente do Planno no WhatsApp por 30 dias',
] as const

export const PT_PRO_PERKS = [
  'Equipe ilimitada',
  'Projetos ilimitados',
  '200 GB por usuário',
  'Assistente do Planno no WhatsApp sem limite de tempo',
  'Planno IA com renders (créditos à parte)',
  'Portal do cliente, clientes não contam como usuários',
  'Suporte prioritário com a equipe',
] as const

export const EN_FREE_PERKS = [
  '1 user',
  '50 GB of storage',
  'Projects (limited)',
  'Briefs, proposals, and CRM',
  'Documents, reports, and checklists',
  'iOS and Android app',
  '30-day trial of the Planno assistant on WhatsApp',
] as const

export const EN_PRO_PERKS = [
  'Unlimited team',
  'Unlimited projects',
  '200 GB per user',
  'Planno assistant on WhatsApp with no time limit',
  'Planno AI with renderings (credits billed separately)',
  'Client portal — clients don’t count as users',
  'Priority support from the team',
] as const
